module.exports = __webpack_public_path__ + "img/spotv-now-golf.82f96bee.png";